export default __webpack_public_path__ + "static/media/quote-tab.61b18c9e.png";